var indentation_default = {
  "indentZero": "IYPcU",
  "indentOne": "ofm66",
  "indentTwo": "puEYf",
  "indentThree": "Ee1aG",
  "indentFour": "Bswc-",
  "indentFive": "qWuCF",
  "indentSix": "AWaW4"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
